module.exports = __webpack_public_path__ + "static/img/mtjz02.1be9c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/mtjz02.png
// module id = HU8k
// module chunks = 11